import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { BlogTags } from '@app/_shared/_enums/blog-tags';
import { SEO, IShopifyProduct } from '@app/_shared/_models';
import { BlogService, ProductService, SeoService } from '@app/_shared/_services';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ProductCardComponent } from '../../_shared/_components/product-card/product-card.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-winterize-with-bioguard',
    templateUrl: './winterize-with-bioguard.component.html',
    styleUrls: ['./winterize-with-bioguard.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ProductCardComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class WinterizeWithBioguardComponent implements OnInit, OnDestroy {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/winterizing-pool.jpg',
    metaDescription: `Curious on how to properly close your pool for Winter? My Pool Hut can help with the BioGuard Winterization Kits. Order online today!`,
    metaTitle: `How to winterize and close your pool. A step by step guide with BioGuard Products.`
  };
  public spinner$: Observable<NgxSpinner>;
  public product$: Observable<IShopifyProduct | undefined>;
  public blogPost!: IBlogPost;
  public winterKit: IShopifyProduct | undefined;
  public algaecide: IShopifyProduct | undefined;
  public shock: IShopifyProduct | undefined;
  public surfaceCleaner: IShopifyProduct | undefined;
  public naturalClarifier: IShopifyProduct | undefined;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
    this.product$ = this.productService.product$;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/winterize-with-bioguard');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.WINTERIZE_WITH_BIOGUARD);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

    this.winterKit = await this.productService.loadProductByHandle('bioguard-arctic-blue-winter-kit');
    this.algaecide = await this.productService.loadProductByHandle('bioguard-arctic-blue-algae-protector');
    this.shock = await this.productService.loadProductByHandle('bioguard-arctic-blue-shock');
    this.surfaceCleaner = await this.productService.loadProductByHandle('bioguard-off-the-wall-surface-cleaner');
    this.naturalClarifier = await this.productService.loadProductByHandle('bioguard-natural-clarifier');
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
